import { Component, OnInit } from '@angular/core';
import * as $ from 'jquery';
import { ConfigService } from 'src/app/service/config.service';

@Component({
  selector: 'app-airport-dashboard',
  templateUrl: './airport-dashboard.component.html',
  styleUrls: ['./airport-dashboard.component.css']
})
export class AirportDashboardComponent implements OnInit {
  public isExpanded = true;
  public css: string;
  public projectColor: string;
  constructor(config: ConfigService) { 
    this.css = config.values.projectCSS;
    this.projectColor = config.values.projectColor;
  }

  ngOnInit() {
  }

  onchange(res) {
    this.isExpanded = res;
    $("#wrapper").toggleClass("toggled");
  }

}
